import { inject, Injectable } from "@angular/core";
import { ParameterService } from "./parameter.service";
import { CurrencyPipe } from "@angular/common";

@Injectable()
export class ChannelService
{
    private readonly parameterService = inject(ParameterService);
    private readonly currencyPipe = inject(CurrencyPipe);

    public getHeader(): string
    {
        const headerContent = this.parameterService.channel?.header ?? '';
        return headerContent === '' ? 'Zahlung' : headerContent;
    }

    public getHeaderLine1(): string | undefined
    {
        let headerLine1: string | undefined = this.parameterService.channel?.header_line1 ?? '';
        headerLine1 = headerLine1 === '' ? undefined : headerLine1;
        if (headerLine1) {
            return headerLine1.replace('${openamount}', this.currencyPipe.transform(this.parameterService.getOpenAmount(), 'EUR', 'symbol' ) ?? '');
        }
        return headerLine1;
    }

    public getHeaderLine2(): string | undefined
    {
        let headerLine2: string | undefined = this.parameterService.channel?.header_line2 ?? '';
        headerLine2 = headerLine2 === '' ? undefined : headerLine2;
        if (headerLine2) {
        return headerLine2.replace('${openamount}', this.currencyPipe.transform(this.parameterService.getOpenAmount(), 'EUR', 'symbol' ) ?? '');
        }
        return headerLine2;
    }

    public getReferenceText(): string
    {
        const ref = this.parameterService.channel?.reference;
        return ref ?? `Referenz`;
    }

    public getReferenceTextWithId(): string
    {
        return `${this.getReferenceText()}: ${this.parameterService.payment?.public_id}`;
    }

}